import { useQuery } from '@apollo/client';

import ActivatedPlanCard from 'components/ActivatedPlanCard';
import { useDevice } from 'hooks/useDevice';
import { ACTIVE_SUBSCRIPTION } from 'queries/subscription';

export default function ActiveSubscription() {
  const { device } = useDevice();
  const { data } = useQuery(ACTIVE_SUBSCRIPTION, {
    variables: { serialNumber: device },
    fetchPolicy: 'network-only',
    skip: !device,
  });
  const subscription = data?.activeSubscription;

  if (!subscription || !subscription?.product?.price) {
    return null;
  }

  return (
    <ActivatedPlanCard
      serialNumber={subscription.device.serialNumber}
      product={subscription?.product}
      subscription={subscription}
      showExpiryDate={true}
    />
  )
}
